import React, { useMemo } from 'react';
import { Card, CardBody, Table } from 'reactstrap';
import withLoader from 'components/organisms/withLoader';
import forms from 'constants/forms';
import { apiAdminPanelPatientEdit } from 'services/dataService/resources';
import { hasPatientAcceptanceRole } from 'utils/accessManager/helpers';
import useUser from 'utils/useUser';
import useTable from 'utils/useTable';
import PatientRow from './components/patientRow';
import PatientsToolbar from './components/toolbar';
import PatientsHeader from './components/header';
import PatientsFooter from './components/footer';

const PER_PAGE = 100;
const AdminPanelPatients = () => {
  const { roleNames } = useUser();
  const iamPatientAcceptance = useMemo(() =>
    hasPatientAcceptanceRole(roleNames),
  );
  const statusOptions = useMemo(() =>
    iamPatientAcceptance
      ? forms.patientOnboardingStatus
      : [{ value: null, label: 'All' }, ...forms.patientStatuses],
  );

  const ccmStatusOptionsByRole = iamPatientAcceptance
    ? forms.ccmStatusOptionsForPatientAcceptanceRole
    : forms.ccmStatusOptions;

  const ccmStatusOptions = useMemo(() => [
    { value: null, label: 'All' },
    ...ccmStatusOptionsByRole,
  ]);

  const DEFAULT_STATUS_VALUE = useMemo(() =>
    iamPatientAcceptance ? statusOptions[0].value : null,
  );
  const DEFAULT_CCMSTATUS_VALUE = useMemo(() =>
    iamPatientAcceptance ? ccmStatusOptions[0].value : null,
  );

  const {
    data: { items },
    count,
    loading,
    page,
    filters,
    setPage,
    setFilters,
  } = useTable(apiAdminPanelPatientEdit(), PER_PAGE, {
    status: DEFAULT_STATUS_VALUE,
    ccmStatus: DEFAULT_CCMSTATUS_VALUE,
  });

  return (
    <div className="adminPanel">
      <Card className="card-border">
        <CardBody className="card-outer">
          <PatientsHeader count={count} />
          <PatientsToolbar
            filters={filters}
            statusOptions={statusOptions}
            ccmStatusOptions={ccmStatusOptions}
            setFilters={setFilters}
            count={count}
            itemsLength={items.length}
            page={page}
            setPage={setPage}
            perPage={PER_PAGE}
          />
          <div className="adminPanel__table-no-width">
            {withLoader(
              loading,
              <Table bordered cellSpacing="0">
                <thead>
                  <tr>
                    <th>
                      <div className="adminPanel__row adminPanel__row--sortng">
                        Patient Name
                      </div>
                    </th>
                    <th>
                      <div className="adminPanel__row adminPanel__row--sortng">
                        RPM Status
                      </div>
                    </th>
                    <th>
                      <div className="adminPanel__row adminPanel__row--sortng">
                        CCM Status
                      </div>
                    </th>
                    <th>
                      <div className="adminPanel__row adminPanel__row--sortng">
                        Clinic
                      </div>
                    </th>
                    <th>
                      <div className="adminPanel__row adminPanel__row--sortng" />
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {items.map((patientRow, index) => (
                    <PatientRow
                      key={`${patientRow.id}-${index}`}
                      data={patientRow}
                      roleNames={roleNames}
                    />
                  ))}
                </tbody>
              </Table>,
            )}
          </div>
          <PatientsFooter
            count={count}
            itemsLength={items.length}
            page={page}
            setPage={setPage}
            perPage={PER_PAGE}
          />
        </CardBody>
      </Card>
    </div>
  );
};

export default AdminPanelPatients;
